import { Event } from '@/feature/event-details-sbk/types';
import { TeamOrder } from '@/utils/sport-utils';

import { MatchupCardLayout } from '../MatchupCardLayout';
import { useMatchupTeamRows } from '../use-matchup-team-rows';
import { MarketColumn } from '../utils';
import { TennisPlayerRow } from './TennisPlayerRow';
import { useTennisScoreboards } from './use-tennis-scoreboard';

type TennisMatchupCardProps = {
    event: Event;
    marketColumns: MarketColumn[];
    totalRows: number;
    teamOrder: TeamOrder;
    showHeader?: boolean;
    isLastItem?: boolean;
    onPress?: () => void;
};

export const TennisMatchupCard = ({
    event,
    marketColumns,
    totalRows,
    teamOrder,
    showHeader,
    isLastItem,
    onPress,
}: TennisMatchupCardProps) => {
    const playerInfoRows = useMatchupTeamRows(event, teamOrder);
    const { home: homeTennisScoreboard, away: awayTennisScoreboard } = useTennisScoreboards(event);

    return (
        <MatchupCardLayout
            event={event}
            marketColumns={marketColumns}
            totalRows={totalRows}
            teamOrder={teamOrder}
            showHeader={showHeader}
            isLastItem={isLastItem}
            onPress={onPress}
        >
            {playerInfoRows.map(playerInfo => {
                const { setScores, gameScore, isServing } =
                    playerInfo.side === 'home' ? homeTennisScoreboard : awayTennisScoreboard;
                return (
                    <TennisPlayerRow
                        key={playerInfo.side}
                        playerName={playerInfo.teamName}
                        logoUrl={playerInfo.logoUrl}
                        primaryColor={playerInfo.primaryColor}
                        secondaryColor={playerInfo.secondaryColor}
                        shouldShowFallbackLogo={playerInfo.shouldShowFallbackLogo}
                        isServing={isServing}
                        setScores={setScores}
                        gameScore={gameScore}
                    />
                );
            })}
        </MatchupCardLayout>
    );
};
